"use client";

import dynamic from "next/dynamic";

export const Footer = dynamic(
  () => import("@/widgets/footer/footer").then((m) => m.Footer),
  { ssr: false },
);
